import { apiCall } from 'api';
import { USER_LOGOUT_PATH_SERVICE } from 'api/services/content/paths';

export const logoutService = params => {
  return apiCall.get(USER_LOGOUT_PATH_SERVICE, { params });
};
